import routes from 'sitewide-js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import {
  PaperUpdate,
  PaperUpdatePayload,
  FollowableUser,
  Tag,
} from 'js/social/shared/types';
import toSnakecaseKeys from 'js/utils/toSnakecaseKeys';

export const createPaperUpdate = async ({
  content,
  tags,
  workId,
  entityId,
  entityType,
  newsType,
}: PaperUpdatePayload): Promise<{
  paperUpdate: PaperUpdate;
  user: FollowableUser;
}> => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_paper_update_index_path({
      subdomain_param: 'api',
    }),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(
        toSnakecaseKeys({
          content,
          tags: tags.map(toSnakecaseKeys),
          workId,
          entityId,
          entityType,
          newsType,
        }),
      ),
    },
  );
  if (response.status !== 200) {
    throw new Error('Failed to create paper update');
  }
  return await response.json();
};

export const editPaperUpdate = async (
  paperUpdateId: string | number,
  content: string,
  tags: Tag[],
): Promise<{ paper_update: PaperUpdate; user: FollowableUser }> => {
  const response = await fetchWithCsrf(
    routes.api_v0_community_paper_update_path({
      subdomain_param: 'api',
      id: paperUpdateId,
    }),
    {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        content: content,
        tags: tags.map(toSnakecaseKeys),
      }),
    },
  );

  if (response.status !== 200) {
    throw new Error('Failed to edit paper update');
  }
  return await response.json();
};
